<script lang="ts" setup>
	export type AlertVariant = 'primary' | 'secondary' | 'warning' | 'error' | 'purple'
	const { variant = 'primary' } = defineProps<{
		variant?: AlertVariant
	}>()

	const detailsPreview = computed(() => {
		const message = {
			class: 'bg-gray-50 border-gray-100',
			icon: {
				dir: 'fill',
				name: 'warning',
				class: 'fill-blue-500'
			}
		}

		if (variant === 'error') {
			message.class = 'bg-error-50 border-error-100'
			message.icon.class = 'fill-error-500'
		} else if (variant === 'warning') {
			message.class = 'bg-warning-50 border-warning-100'
			message.icon.class = 'fill-warning-500'
		} else if (variant === 'purple') {
			message.class = 'bg-purple-50 border-purple-100'
			message.icon.class = 'fill-purple-500'
		}

		return message
	})
</script>

<template>
	<div
		class="flex min-h-[64px] flex-wrap items-center justify-between gap-4 rounded-lg border py-2 pl-5 pr-2 text-base font-medium tracking-wide"
		:class="detailsPreview.class"
	>
		<div class="flex items-center gap-x-3">
			<lazy-tools-icon
				:icon="detailsPreview.icon.name"
				:dir="detailsPreview.icon.dir"
				:path-class="detailsPreview.icon.class"
				:height="20"
				:width="20"
			/>
			<div class="text-base font-medium text-gray-600">
				<slot />
			</div>
		</div>

		<slot name="prefix" />
	</div>
</template>
